import React from "react";
import ComingSoon from "components/admin/ComingSoon";

const AdminReservations: React.FC = () => (
  <ComingSoon
    icon="📅"
    title="예약 관리"
    features={[
      "전체 예약 현황 조회 및 필터",
      "예약 상태 변경 (확정 · 취소)",
      "날짜 · 시설별 예약 캘린더 뷰",
      "이용 시간 초과 · 미반납 알림",
      "예약 통계 및 기간별 리포트",
    ]}
  />
);

export default AdminReservations;
